import React, {useEffect, useState} from 'react';
import {ContainerHeader} from "../../module";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router";
import useValidation from "../../../validation/useValidation";
import DatePicker from "react-datepicker2";
import "./user.css";
import {initUserForm, onUserFormChange, selUserForm} from "../../../stores/user/userSlice";
import {FormUserInit, userValidations} from "../../../stores/user/userModel";
import {createUser, editUser, getUserById} from "../../../stores/user/userThunk";
import moment from 'moment-jalaali';
import {notification} from "../../functions/notification/notificationFunction";

export default function User() {

    const user = useSelector(selUserForm);

    const { first_name, last_name, gender, mobile, email, birthday } = user;
    const provinces = [
        {
            name: "مرد",
            value: 21
        },
        {
            name: "زن",
            value: 20
        }
    ];
    const dispatch = useDispatch();
    const {id} = useParams();
    const history = useHistory();

    const {errors, checkFiled, checkValidation} = useValidation({
        data: userValidations,
        key: 'userForm',
    });

    function setParametersMain(event) {
        const {value, name} = event.target;
        checkFiled(name, value);
        dispatch(onUserFormChange({name, value}))
    }

    function backToUsers() {
        history.push('/users');
    }

    const redirectToUsers =()=> history.push("/users")

    async function addUser(){
        const data = {
            first_name: first_name,
            last_name: last_name,
            gender: gender,
            mobile: mobile,
            email: email,
            birth_day: birthday,
        }

        const check = await checkValidation(data);
        if (!check) return dispatch(notification("error","خوش آمدید",<h3>فیلد های قرمز رنگ را پر کنید</h3>,false))
        dispatch(createUser(data, redirectToUsers))
    }

    async function putUser(){
        const data = {
            first_name: first_name,
            last_name: last_name,
            gender: gender,
            mobile: mobile,
            email: email,
            birth_day: birthday,
        }
        const check = await checkValidation(data);
        if (!check) return dispatch(notification("error","خوش آمدید",<h3>فیلد های قرمز رنگ را پر کنید</h3>,false))
        dispatch(editUser(id, data, redirectToUsers))
    }

    function setTime(e, name) {
        const value = moment(e).format(`YYYY-MM-DD`)
        checkFiled(name, moment(e).format(`YYYY-MM-DD`));
        dispatch(onUserFormChange({name, value: moment(e).format(`YYYY-MM-DD`)}))
        // setStaticState(prevState => (
        //     {
        //         ...prevState, [name]: e.format(`jYYYY/jMM/jDD`),
        //         [`dateForSend`]: e.format(`YYYY/MM/DD`)
        //     }
        // ));
    }


    useEffect(() => {
        id ?
            dispatch(getUserById({id}))
            :
            dispatch(initUserForm(FormUserInit))
        return ()=>{
            dispatch(initUserForm(FormUserInit))
        }
    }, [id]);

    console.log(moment(birthday , 'YYYY-MM-DD'))

    return (
        <Grid item xs={11} sm={12}
              className="w-100 d-flex flex-column DivParentCreateProduct ContentCreateAttribute">
            <ContainerHeader
                data={{
                    filter: false,
                    backBtn: true,
                }}
                headerTitle="افزودن کاربر"
                backBtnTitle="بازگشت"
                backBtnAction={backToUsers}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />

            <Paper className="parentContentCreateProduct">
                <div className="w-100">

                    <div className="w-100">
                        <div className="d-flex flex-column">
                            <Grid container spacing={2}
                                  className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'نام'}
                                        variant="outlined"
                                        name={'first_name'}
                                        value={first_name}
                                        error={errors.first_name}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'نام خانوادگی'}
                                        variant="outlined"
                                        name={'last_name'}
                                        value={last_name}
                                        error={errors.last_name}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <DatePicker
                                        isGregorian={false}
                                        className={`DatePickerUserPanel ${errors.birthday && "redBorder"}`}
                                        timePicker={false}
                                        value={ birthday !== null ? moment(birthday , 'YYYY-MM-DD') : null }
                                        onChange={(e) => setTime(e, 'birthday')}
                                        placeholder={`تاریخ تولد`}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <Autocomplete
                                        className={`w-100`}
                                        value={gender && provinces.find(data=> data.value === gender)}
                                        options={provinces}
                                        getOptionLabel={(option) => option.name}
                                        onChange={(event, value) => {
                                            checkFiled('gender', value?.value);
                                            dispatch(onUserFormChange({name: 'gender', value: value?.value}))
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params}
                                                       error={errors?.gender}
                                                       variant="outlined"
                                                       className={`w-100`}
                                                       label="جنسیت"/>
                                        )}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'موبایل'}
                                        variant="outlined"
                                        name={'mobile'}
                                        value={mobile}
                                        error={errors.mobile}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'ایمیل'}
                                        variant="outlined"
                                        name={'email'}
                                        value={email}
                                        error={errors.email}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <Button
                            variant="contained"
                            onClick={ id ? putUser : addUser }
                            className="continuationButtonCreateProduct mr-3 mt-5"
                        >
                            {id ? "ویرایش" : "ایجاد"}
                        </Button>
                    </div>
                </div>
            </Paper>
        </Grid>
    );
}
